import { defineStore } from 'pinia'
import WarehouseService from "@/services/warehouse.service.ts";
export const useWarehouseStore = defineStore('warehouse', {
    state: () => {
        return {
            warehouses: [],
            warehousesLimit: [],
            usingWarehouse: null,
            warehouse: null,
            paginate: {},
            lastPage: 1,
        }
    },
    persist: true,
    actions: {
        async getListWarehouses(url, params) {
            try {
                const res = await WarehouseService.getListWarehouses(url, params)
                this.warehouses = res.data
            } catch (e) {
                return null
            }
        },
        async getListWarehousesWithLimit(url, params) {
            try {
                const res = await WarehouseService.getListWarehouses(url, params)
                this.warehouses = res.data.data
                this.paginate = res.data.meta
                this.lastPage = res.data.meta.page
            } catch (e) {
                return null
            }
        },
        async getWarehouseDetail(url, params) {
            try {
                const res = await WarehouseService.getWarehouseDetail(url, params)
                this.warehouse = res.data
            } catch (e) {
                return null
            }
        },
        async createOrUpdateWarehouse(url, params) {
            try {
                const res = await WarehouseService.createOrUpdateWarehouse(url, params)
                return res.data;
            } catch (e) {
                return null
            }
        },
    }
})
